
import { Component, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import { getResource, postResource } from '../../../../../framework/client/resource';
import TextField from '../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import { PurchaseInvoice } from '../../../../../../common/application/model/PurchaseInvoice';
import { getEnumerationOptions } from '../../../../../framework/service/options';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import { getVendorOptions } from '../../../../service/application_options_service';
import NumberField from '../../../../../framework/fields/NumberField.vue';
import DateField from '../../../../../framework/fields/DateField.vue';
import { VendorType } from '../../../../../../common/application/model/enums/VendorType';
import { Vendor } from '../../../../../../common/application/model/Vendor';
import { ValidationObserver } from 'vee-validate';
import { PurchaseInvoiceState } from '../../../../../../common/application/model/enums/PurchaseInvoiceState';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { successToast, errorToast } from '../../../../service/toast_service';
import { updateCachedResourceRow } from '../../../../service/query_cache_service';

@Component({
    components: { DateField, NumberField, SwitchField, SelectField, TextField, ValidationObserver },
})
export default class AddPurchaseInvoice extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE;

    // Properties

    // State
    shared = sharedState;
    local = {
        row: {
            accrualRuleApplied: false,
            paymentTermsCode: '',
        } as PurchaseInvoice,
        purchaseInvoiceStateOptions: [] as { id: string | undefined; label: string }[],
        vendorOptions: [] as { id: string | undefined; label: string }[],
        vendorTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        // Accepted only ever comes from Netvisor; the server rejects it too.
        this.local.purchaseInvoiceStateOptions = getEnumerationOptions(
            'PurchaseInvoiceState',
            Object.keys(PurchaseInvoiceState).filter((key) => key !== 'ACCEPTED'),
            this,
        );
        this.local.vendorOptions = await getVendorOptions();
        this.local.vendorTypeOptions = getEnumerationOptions('VendorType', Object.keys(VendorType), this);
    }

    @Watch('local.row.vendorId')
    async vehicleContractIdChange(vendorId: string | undefined) {
        if (vendorId) {
            const vendor = await getResource<Vendor>(ApplicationResource.VENDOR, vendorId);
            if (vendor) {
                this.local.row = {
                    ...this.local.row,
                    vendorType: vendor.vendorType,
                    vendorName: vendor.name,
                    vendorNumber: vendor.vendorNumber,
                };
            }
        } else {
            this.local.row = {
                ...this.local.row,
                vendorType: VendorType.UNSPECIFIED,
                vendorName: '',
                vendorNumber: '',
            };
        }
    }

    add() {
        this.addResource(false);
    }

    addAndClose() {
        this.addResource(true);
    }

    async addResource(goBack: boolean) {
        try {
            const newPurchaseInvoice = await postResource<PurchaseInvoice>(this.resourceType, this.local.row);
            successToast(this, 'message.purchaseInvoiceSaved');
            updateCachedResourceRow<PurchaseInvoice>(newPurchaseInvoice, newPurchaseInvoice.id, this.resourceType);

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
